import {i18n} from "@lingui/core";

import "@formatjs/intl-pluralrules/locale-data/en";
import { messages as en } from "../../../../locales/en/messages.po";
import "@formatjs/intl-pluralrules/locale-data/hr";
import { messages as hr } from "../../../../locales/hr/messages.po";
import {detect, fromNavigator, fromStorage} from "@lingui/detect-locale";

const DEFAULT_FALLBACK = () => 'en';

export const DEFAULT_LOCALE = detect(fromStorage('locale'), fromNavigator(), DEFAULT_FALLBACK) || DEFAULT_FALLBACK();

export const localeNames = {
    
    'en': 'English',
    'hr': 'Hrvatski',
}

export const locales = Object.keys(localeNames)

const localeMessages = {
    
    'en': en,
    'hr': hr,
}

function isLanguageCodeSupported(languageCode: string) {
    return locales.includes(languageCode);
}

export const defaultLocale = isLanguageCodeSupported(DEFAULT_LOCALE) ? DEFAULT_LOCALE : DEFAULT_FALLBACK();

export default function activateLocale() {
    i18n.load(localeMessages)
    i18n.activate(defaultLocale, locales);
    return i18n;
}

export function dynamicActivateLocale(locale: string) {
    i18n.activate(locale);
}
